(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ClinicName', ClinicName);

    ClinicName.$inject = ['$resource'];

    function ClinicName ($resource) {
        var resourceUrl =  'api/clinic-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
